import { IntegratedIReckonRoom } from '@era/locations-sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegrationResolverActions = createActionGroup({
  source: 'IReckon integration resolver',
  events: {
    'IReckon integration requested': props<{ roomUniqueId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IntegrationApiActions = createActionGroup({
  source: 'Integration API',
  events: {
    'IReckon integrations loaded': props<{ rooms: IntegratedIReckonRoom[] }>(),
    'IReckon integrations loaded error': props<{ error: ErrorModel }>(),
    'IReckon integration added': props<{ room: IntegratedIReckonRoom }>(),
    'IReckon integration added error': props<{ room: IntegratedIReckonRoom; error: ErrorModel }>(),
    'IReckon integration updated': props<{ room: IntegratedIReckonRoom }>(),
    'IReckon integration updated error': props<{ room: IntegratedIReckonRoom; error: ErrorModel }>(),
    'IReckon integration deleted': props<{ room: IntegratedIReckonRoom }>(),
    'IReckon integration deleted error': props<{ room: IntegratedIReckonRoom; error: ErrorModel }>(),
    'No IReckon integrations': emptyProps(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegrationContainerActions = createActionGroup({
  source: 'IReckon integration container',
  events: {
    'IReckon integration updated': props<{ room: IntegratedIReckonRoom }>(),
    'IReckon integration deleted': props<{ room: IntegratedIReckonRoom }>(),
  },
});
